import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticle from './components/FeaturedArticle';
import WhyChooseUs from './components/WhyChooseUs';
import FAQSection from './components/FAQSection';
import { faqItems } from '@/mocks/categories';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.buzz';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

const pageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
    {
      '@type': 'WebSite',
      '@id': siteUrl + '/#website',
      url: siteUrl,
      name: 'CSSSpreadsheet.buzz',
      description: 'The ultimate CSSBuy Spreadsheet directory — discover 15,000+ verified products, 500+ trusted sellers, daily updates, and comprehensive shopping guides.',
      publisher: {
        '@type': 'Organization',
        '@id': siteUrl + '/#organization',
        name: 'CSSSpreadsheet.buzz',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: logoUrl,
        },
      },
    },
    {
      '@type': 'Organization',
      '@id': siteUrl + '/#organization',
      name: 'CSSSpreadsheet.buzz',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategoryDropdown />
        <CategoryGrid />
        <FeaturedArticle />
        <WhyChooseUs />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}